<template>
  <div v-if="!pending" class="tailwind">
    <PointsCalculator
      :title="properties.text.title"
      :description="properties.text.description"
      :memberLink="properties.linkMember"
      :noMemberLink="properties.link"
      @open-simple-calendar="onOpenSimpleCalendar"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { PointsCalculator } from '@common/lib-vue-common'
import { startUpLabels } from './composables/useLabels.js'

const properties = window.appGlobalProps.pointsCalculator

const pending = ref(true)
onMounted(async () => {
  await startUpLabels()
  pending.value = false
})
const onOpenSimpleCalendar = searchbarParams => {
  window.searchBarVue.$emit('open-searchbar-modal', searchbarParams)
}
</script>
